<template>
<div>
    <Nav isActive="home"/>
    <div class="pageWD mT20 shadowBox  minHeight">
      <div class="nlist"> 
        <el-row>
            <el-col :span="6" class="leftbar"> 
              <div class="title">公告列表</div> 
              <div class="item" :class="[activeIndex==index?'active':'']" v-for="(item,index) in noticeList" :key="index" @click="tapClick(index,item)">
                <div class="c3 f16" :class="[item.noIsRead=='0'?'pre':'']">{{item.noTitle}}</div>
                <div class="c9 f14">{{$conFun.parseData(item.noCreatedon)}}</div>
              </div>
            </el-col>
            <el-col :span="18" v-if="detail" class="detail">   
                <div class="f18 c3 name">{{detail.noTitle}}</div>
                <div class="f14 c9">发布人：{{detail.publishName}}  <span style="padding-left:24px">{{$conFun.parseData(detail.noCreatedon)}}</span></div>
                <div class="dep f18 c6" v-html="detail.noContent"></div>  
            </el-col>
        </el-row>        
      </div>  
    </div>
</div> 
</template>
<script>
import Cookies from "js-cookie";
import Nav from "../../../components/Nav.vue";
import { getNoticeDetail} from '@/api/api'
export default {
  components: { Nav },
  data() {
    return {
      noticeList:[],
      activeIndex:this.$route.query.index?this.$route.query.index:'0',
      //activeIndex:'-1',
      detail:null,
      noId:this.$route.query.id?this.$route.query.id:'',
    }
  },
  created() {
    this.getNoticeList()
  },
   watch: {
    $route(to, from) {
      this.activeIndex = to.query.index
      this.noId = to.query.id
      this.getDetail(this.noId)
    }
  },
  methods: { 
    tapClick(index,item){   
      this.activeIndex = index
      this.getDetail(item.noId)
    },   
    getNoticeList() {
      var that = this
      this.$store
        .dispatch("getNoticeList", '50')
        .then((res) => {          
          that.noticeList = res.body.result          
          if(that.noId){
            that.getDetail(that.noId)  
          }else{
            that.getDetail(res.body.result[0].noId)  
          }
              
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDetail(noId,index){
      let data = {
        noId: noId,
        memberId:Cookies.get('qslmemberId') 
      };
      var that = this
      getNoticeDetail(data)
        .then(res => {         
          that.detail = res.body.result
        })
        .catch(err => {});
    } 
  }
}
</script>

<style scoped>
  .nlist .item{
    cursor: pointer;
    padding:24px 24px 24px 16px;
     border-left:8px solid #fff;
  }
  .nlist .item .f16{   
    padding-bottom:14px;
  }
  .nlist .item .pre{   
    position: relative;
    padding-left:16px
  }
  .nlist .item .pre::before{   
    content: '';
    width:8px;
    height:8px;
    background: red;
    border-radius: 100%;
    position: absolute;
    left:0;
    top:7px
  }
  .nlist .item:hover{
    
   
  }
  
    .nlist .item:hover .c3{
    color: #4b9afb;
  
  }
  .nlist .active{
    border-left:8px solid #4b9afb;
    box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.15); 
  }
  .nlist .active .f16{
    color: #4B9AFB;
  }
  .nlist .title{
    width: 100%;
    height: 91px;
    line-height:91px;
    font-size: 18px;
    padding-left:24px;
    background: #ffffff;
    border-radius:8px
  }
  .nlist .detail{
    padding:24px
  }
    .nlist .name{
    padding:15px 0 14px 0;
    font-weight:bold
  }
  .nlist .detail .dep{
    line-height: 27px;
    padding-top:20px;
  }
</style>


// WEBPACK FOOTER //
// src/views/home/Notice/index.vue